import type { ProjectPromptResult } from '@cli-types/next-adapter/init.js'

export function resolveNonInteractiveProject(name: string | undefined): ProjectPromptResult {
  const projectName = name?.trim() || 'my-app'

  if (projectName !== '.' && !/^[a-z0-9_-]+$/i.test(projectName)) {
    throw new Error('Project name can only contain letters, numbers, hyphens, and underscores')
  }

  return { projectName }
}
